import { motion, useInView } from "framer-motion";
import { useRef } from "react";
import { getGreeting } from "../utils/GreetingHelper";

const Banner = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-100px" }); 
  // once: true = animasi hanya sekali
  // margin = trigger lebih cepat saat mendekati layar
 const bannerText = process.env.REACT_APP_BANNER ?? "";
 const bannerTextShort = process.env.REACT_APP_SHORT_BANNER ?? "";
  return (
    <div
      ref={ref}
      className="flex items-center justify-center "
    >
      <div className="flex items-center justify-center md:flex-row sm:flex-col flex-col w-[330px] sm:w-[330px] md:w-full bg-white/30 backdrop-blur-md rounded-3xl p-6 shadow-lg">
        {/* Welcome Box */}
        <motion.div
            initial={{ opacity: 0, y: 50 }} // posisi awal
            whileInView={{ opacity: 1, y: 0 }} // animasi saat masuk viewport
            transition={{ duration: 0.8, ease: "easeOut" }}
            viewport={{ once: false, amount: 0.2 }} // jalan berulang, trigger saat 20% terlihat
          className="w-full sm:w-full md:w-2/4 h-auto p-6 text-center pull-right"
        >
          <h3 className="text-xl md:text-5xl font-semibold tracking-tight text-gray-900 sm:text-7xl">
            {getGreeting()}, I'm Fullstack Developer
          </h3>
          <h1 className="text-xl md:text-4xl font-extrabold bg-gradient-to-r from-blue-500 via-indigo-600 to-purple-700 bg-clip-text text-transparent">
            Nurhadi Novrianto
          </h1>
          <div className="mt-10 hidden md:block w-full mx-auto p-8">
            <p className="text-justify text-md md:text-xl">
              {bannerText}
            </p>
            <a href="#service" className="text-sm font-semibold text-gray-900">
              Read more <span aria-hidden="true">→</span>
            </a>
          </div>
        </motion.div>

        {/* Profile Box */}
        <motion.div
          initial={{ opacity: 0, scale: 0.9 }}
          animate={isInView ? { opacity: 1, scale: 1 } : {}}
          transition={{ duration: 0.8, delay: 0.2, ease: "easeOut" }}
          className="w-full md:w-[200px] h-auto text-center flex flex-col items-center justify-start"
        >
          <img
            src={"./img/pas-foto.jpg"}
            alt="Profile"
            className="mx-auto w-32 h-32 sm:w-40 sm:h-40 md:w-48 md:h-48 rounded-full bg-white p-4 mb-4 object-cover object-top"
          />
          <div className=" md:hidden w-full mx-auto p-8">
            <p className="text-center text-sm md:text-xl font-regular font-montserrat">
              {bannerTextShort}
            </p>
          </div>

        </motion.div>
      </div>
    </div>
  );
};

export default Banner;
